// Australian state / territory metadata for the frontend.
export const STATES = [
 { code: "QLD", name: "Queensland", tribunal: "QCAT" },
 { code: "NSW", name: "New South Wales", tribunal: "NCAT" },
 { code: "VIC", name: "Victoria", tribunal: "VCAT" },
 { code: "SA", name: "South Australia", tribunal: "SACAT" },
 { code: "WA", name: "Western Australia", tribunal: "Magistrates Court" },
 { code: "TAS", name: "Tasmania", tribunal: "Residential Tenancy Commissioner" },
 { code: "NT", name: "Northern Territory", tribunal: "NTCAT" },
 { code: "ACT", name: "Australian Capital Territory", tribunal: "ACAT" },
];

export const STATE_RESOURCES = {
 QLD: [
 ["Tenants Queensland", "https://tenantsqld.org.au"],
 ["RTA Queensland", "https://www.rta.qld.gov.au"],
 ["QCAT", "https://www.qcat.qld.gov.au"],
 ],
 NSW: [
 ["Tenants' Union NSW", "https://www.tenants.org.au"],
 ["NSW Fair Trading", "https://www.fairtrading.nsw.gov.au"],
 ["NCAT", "https://www.ncat.nsw.gov.au"],
 ],
 VIC: [
 ["Tenants Victoria", "https://tenantsvic.org.au"],
 ["Consumer Affairs Victoria", "https://www.consumer.vic.gov.au"],
 ["VCAT", "https://www.vcat.vic.gov.au"],
 ],
 SA: [
 ["RentRight SA", "https://www.rentright.org.au"],
 ["Consumer & Business Services SA", "https://www.cbs.sa.gov.au"],
 ["SACAT", "https://www.sacat.sa.gov.au"],
 ],
 WA: [
 ["Tenancy WA", "https://www.tenancywa.org.au"],
 ["Consumer Protection WA", "https://www.consumerprotection.wa.gov.au"],
 ["Magistrates Court WA", "https://www.magistratescourt.wa.gov.au"],
 ],
 TAS: [
 ["Tenants' Union of Tasmania", "https://tutas.org.au"],
 ["Consumer, Building & Occupational Services TAS", "https://www.cbos.tas.gov.au"],
 ["Magistrates Court Tasmania", "https://www.magistratescourt.tas.gov.au"],
 ],
 NT: [
 ["Darwin Community Legal Service", "https://dcls.org.au"],
 ["Consumer Affairs NT", "https://consumeraffairs.nt.gov.au"],
 ["NTCAT", "https://ntcat.nt.gov.au"],
 ],
 ACT: [
 ["Tenants' Union ACT", "https://www.tenantsact.org.au"],
 ["Access Canberra", "https://www.accesscanberra.act.gov.au"],
 ["ACAT", "https://www.acat.act.gov.au"],
 ],
};

export const stateName = (code) => STATES.find(s => s.code === code)?.name || code;
export const stateTribunal = (code) => STATES.find(s => s.code === code)?.tribunal || "tribunal";
